import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';

const DividendsDistributionModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useDividendsDistributionModal();

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{t('DividendsDistribution')}</h5>
        <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>
    </>
  );
};

export default DividendsDistributionModalHeader;
